export default __webpack_public_path__ + "static/Tek_Chestpiece-eb4cb57b3a82d3bc651567c8f8b23492.png";